<template>
  <div>
    <div class="page-header">
      <h2><span class="breadcrumb-level">商城</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">商品</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">商品管理</span></h2>
      <div class="header-actions">
        <el-input v-model="searchKeyword" placeholder="搜索商品名..." clearable prefix-icon="Search" style="width:180px" @input="onSearchInput" />
        <el-select v-model="filterCatId" placeholder="类目筛选" clearable style="width:140px" @change="fetchData">
          <el-option v-for="c in categories" :key="c.id" :label="c.name" :value="c.id"/>
        </el-select>
        <el-button @click="showCartConfig">购物车限制</el-button>
        <el-button type="primary" @click="showDialog(false)">新增商品</el-button>
      </div>
    </div>
    <el-table :data="list" stripe v-loading="loading">
      <el-table-column label="封面" width="60"><template #default="{row}"><el-image :src="row.cover_image" style="width:36px;height:36px;border-radius:4px" fit="cover"/></template></el-table-column>
      <el-table-column label="商品名" prop="title" min-width="150"/>
      <el-table-column label="类目" width="100"><template #default="{row}">{{row.category?.name||'-'}}</template></el-table-column>
      <el-table-column label="价格" width="100"><template #default="{row}">¥{{row.price}}</template></el-table-column>
      <el-table-column label="库存" width="60"><template #default="{row}">{{row.stock}}</template></el-table-column>
      <el-table-column label="推荐" width="60"><template #default="{row}"><el-switch v-model="row.is_recommended" @change="quickUpdate(row,'is_recommended')" size="small"/></template></el-table-column>
      <el-table-column label="操作" width="200"><template #default="{row}"><el-button size="small" @click="showDialog(true,row)">编辑</el-button><el-button size="small" @click="showSkuDialog(row)">SKU</el-button><el-button size="small" type="danger" @click="handleDelete(row)">删除</el-button></template></el-table-column>
    </el-table>

    <el-pagination
      v-if="pagination.total > 0"
      v-model:current-page="pagination.current_page"
      v-model:page-size="pagination.per_page"
      :total="pagination.total"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10,20,50]"
      small
      background
      style="margin-top:16px;justify-content:flex-end"
      @current-change="fetchData"
      @size-change="fetchData"
    />

    <!-- 商品编辑弹窗（基本信息） -->
    <el-dialog v-model="dialogVisible" :title="isEdit?'编辑商品':'新增商品'" width="750px">
      <el-form ref="formRef" :model="form" :rules="{title:[{required:true}],category_id:[{required:true}]}" label-width="110px">
        <el-form-item label="所属类目" prop="category_id"><el-select v-model="form.category_id" style="width:100%"><el-option v-for="c in categories" :key="c.id" :label="c.name" :value="c.id"/></el-select></el-form-item>
        <el-form-item label="商品名称" prop="title"><el-input v-model="form.title"/></el-form-item>
        <el-form-item label="封面图"><Upload v-model="form.cover_image" :max-count="1" tip="推荐尺寸 宽 690 × 高 470 px" /></el-form-item>
        <el-form-item label="简介"><el-input v-model="form.intro" type="textarea" :rows="2"/></el-form-item>
        <el-form-item label="推荐显示"><el-switch v-model="form.is_recommended"/></el-form-item>
        <el-form-item label="详情"><RichTextEditor v-model="form.content" /></el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" @click="handleSave">保存基本信息</el-button>
      </template>
    </el-dialog>

    <!-- 购物车限制配置弹窗 -->
    <el-dialog v-model="cartConfigVisible" title="购物车限制" width="450px">
      <el-form :model="cartConfig" label-width="160px">
        <el-form-item label="最大商品种类数">
          <el-input-number v-model="cartConfig.max_items" :min="1" :max="100" style="width:100%" />
          <div style="font-size:12px;color:#999;margin-top:4px;">购物车最多同时存放 N 种商品，默认 20</div>
        </el-form-item>
        <el-form-item label="单个商品最大购买数">
          <el-input-number v-model="cartConfig.max_per_item" :min="1" :max="100" style="width:100%" />
          <div style="font-size:12px;color:#999;margin-top:4px;">同一种商品最多购买 N 件，默认 20</div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="cartConfigVisible=false">取消</el-button>
        <el-button type="primary" @click="handleSaveCartConfig" :loading="cartConfigSaving">保存</el-button>
      </template>
    </el-dialog>

    <!-- SKU 管理弹窗 -->
    <el-dialog v-model="skuDialogVisible" title="规格管理" width="700px">
      <div style="margin-bottom:12px;color:#909399;font-size:13px;">同一商品的不同规格（价格/库存不同），标⭐的为列表默认展示规格。</div>
      <el-table :data="skuList" border>
        <el-table-column label="规格" width="200">
          <template #default="{row,$index}">
            <div style="display:flex;gap:4px;align-items:center;">
              <el-select v-model="row.specName" placeholder="名称" size="small" style="width:70px">
                <el-option label="规格" value="规格" />
              </el-select>
              <el-input v-model="row.specValue" placeholder="值" size="small" style="width:80px" />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="图片" width="100">
          <template #default="{row}">
            <Upload v-model="row.cover_image" :max-count="1" tip="推荐尺寸 宽 690 × 高 470 px" />
          </template>
        </el-table-column>
        <el-table-column label="价格" width="120">
          <template #default="{row}"><el-input-number v-model="row.price" :precision="2" :min="0" size="small" style="width:100px"/></template>
        </el-table-column>
        <el-table-column label="库存" width="100">
          <template #default="{row}"><el-input-number v-model="row.stock" :min="0" size="small" style="width:80px"/></template>
        </el-table-column>
        <el-table-column label="默认" width="70">
          <template #default="{row,$index}">
            <el-radio v-model="defaultSkuIndex" :label="$index" size="small">⭐</el-radio>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="70">
          <template #default="{row,$index}">
            <el-button size="small" text type="danger" @click="skuList.splice($index,1);updateDefaultIndex()">删</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top:12px;display:flex;gap:8px;">
        <el-button @click="addSkuRow">+ 新增规格</el-button>
        <el-button type="primary" @click="handleSaveSku">保存规格</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import RichTextEditor from '../../components/RichTextEditor.vue';
import * as api from '../../api/mall';
import Upload from '../../components/Upload.vue';

const list = ref([]);
const filterCatId = ref('');
const categories = ref([]);
const loading = ref(false);
const pagination = reactive({ current_page: 1, per_page: 20, total: 0, last_page: 1 });
const dialogVisible = ref(false);
const cartConfigVisible = ref(false);
const cartConfigSaving = ref(false);
const cartConfig = ref({ max_items: 20, max_per_item: 20 });
const skuDialogVisible = ref(false);
const isEdit = ref(false);
const currentSpuId = ref(null);
const currentSkuId = ref(null);
const formRef = ref(null);


const form = ref({
  category_id: '', title: '', cover_image: '', intro: '',
  content: '', delivery_type: 'both', is_recommended: false,
});

const skuList = ref([]);
const defaultSkuIndex = ref(0);

const searchKeyword = ref('');
let searchTimer = null;
const onSearchInput = () => { clearTimeout(searchTimer); searchTimer = setTimeout(fetchData, 300); };
const fetchData = async () => {
  loading.value = true;
  try { const params = { page: pagination.current_page, per_page: pagination.per_page }; if (searchKeyword.value) params.search = searchKeyword.value; if (filterCatId.value) params.category_id = filterCatId.value; const r = await api.getMallProducts(params); list.value = r.data || []; pagination.current_page = r.pagination?.current_page || 1; pagination.total = r.pagination?.total || 0; }
  catch { ElMessage.error('获取失败'); }
  finally { loading.value = false; }
};

const fetchCats = async () => {
  try { const r = await api.getMallCategories(); categories.value = r.data || []; }
  catch {}
};

const showDialog = (edit, row) => {
  isEdit.value = edit;
  if (edit && row) {
    currentSpuId.value = row.spu_id;
    currentSkuId.value = row.id;
    form.value = {
      category_id: row.category_id || '',
      title: row.title || '',
      cover_image: row.cover_image || '',
      intro: row.intro || '',
      content: row.content || '',
      delivery_type: row.delivery_type || 'both',
      is_recommended: row.is_recommended || false,
    };
  } else {
    currentSpuId.value = null;
    currentSkuId.value = null;
    form.value = { category_id: '', title: '', cover_image: '', intro: '', content: '', delivery_type: 'both', is_recommended: false };
    skuList.value = [{ specName: '规格', specValue: '', price: 0, stock: 0 }];
    defaultSkuIndex.value = 0;
  }
  dialogVisible.value = true;
};

const handleSave = async () => {
  const valid = await formRef.value.validate().catch(() => false);
  if (!valid) return;
  try {
    if (isEdit.value) {
      await api.updateMallProduct(currentSkuId.value, form.value);
      ElMessage.success('基本信息已保存');
    } else {
      const r = await api.createMallProduct({ ...form.value, category_id: Number(form.value.category_id), price: 0, stock: 0, is_default: true });
      currentSpuId.value = r.data?.id;
      currentSkuId.value = r.data?.id;
      // 为新商品建立 spu_id
      if (currentSpuId.value) {
        await api.updateMallProduct(currentSpuId.value, { spu_id: currentSpuId.value });
      }
      ElMessage.success('基本信息已保存，请继续配置规格');
    }
    dialogVisible.value = false;
    if (currentSpuId.value) {
      skuDialogVisible.value = true;
      await loadSkuList();
    }
    await fetchData();
  } catch { ElMessage.error('操作失败'); }
};

// SKU 管理
const showSkuDialog = async (row) => {
  currentSpuId.value = row.spu_id;
  // 同步基本信息到 form
  form.value = {
    category_id: row.category_id || '',
    title: row.title || '',
    cover_image: row.cover_image || '',
    intro: row.intro || '',
    content: row.content || '',
    delivery_type: row.delivery_type || 'both',
    is_recommended: row.is_recommended || false,
  };
  skuDialogVisible.value = true;
  await loadSkuList();
};

const loadSkuList = async () => {
  if (!currentSpuId.value) return;
  try {
    const r = await api.getMallProductsBySpu(currentSpuId.value);
    const skus = r.data || [];
    skuList.value = skus.map(p => {
      return {
        id: p.id,
        specName: '规格',
        specValue: p.specs || '',
        cover_image: p.cover_image || '',
        price: p.price || 0,
        stock: p.stock || 0,
      };
    });
    const defaultIdx = skus.findIndex(p => p.is_default === true || p.is_default === 1 || p.is_default === '1');
    defaultSkuIndex.value = defaultIdx >= 0 ? defaultIdx : 0;
  } catch { skuList.value = []; }
};

const addSkuRow = () => {
  skuList.value.push({ specName: '规格', specValue: '', cover_image: '', price: 0, stock: 0 });
};

const updateDefaultIndex = () => {
  if (defaultSkuIndex.value >= skuList.value.length) {
    defaultSkuIndex.value = skuList.value.length - 1;
  }
};

const handleSaveSku = async () => {
  if (!currentSpuId.value) return;
  for (const sku of skuList.value) {
    if (!sku.specValue) { ElMessage.warning('请填写规格值'); return; }
  }
  try {
    const catId = Number(form.value.category_id);
    if (!catId) { ElMessage.warning('请先选择所属类目'); return; }

    // 获取当前数据库中该 SPU 下的所有 SKU ID
    const existing = await api.getMallProductsBySpu(currentSpuId.value);
    const existingIds = (existing.data || []).map(p => p.id);

    // 找出要保留的 ID
    const keepIds = skuList.value.map(s => s.id).filter(id => id);

    // 删除不在列表中的 SKU
    for (const oldId of existingIds) {
      if (!keepIds.includes(oldId)) {
        await api.deleteMallProduct(oldId);
      }
    }

    // 创建/更新
    for (let i = 0; i < skuList.value.length; i++) {
      const sku = skuList.value[i];
      const data = {
        spu_id: currentSpuId.value,
        category_id: catId,
        title: form.value.title,
        cover_image: sku.cover_image || form.value.cover_image,
        intro: form.value.intro,
        content: form.value.content,
        delivery_type: form.value.delivery_type,
        is_recommended: form.value.is_recommended,
        specs: sku.specValue,
        price: sku.price,
        stock: sku.stock,
        is_default: i === defaultSkuIndex.value,
      };
      if (sku.id) {
        await api.updateMallProduct(sku.id, data);
      } else {
        await api.createMallProduct(data);
      }
    }
    ElMessage.success('规格已保存');
    skuDialogVisible.value = false;
    await fetchData();
  } catch { ElMessage.error('保存失败'); }
};

const showCartConfig = async () => {
  try {
    const res = await api.getCartConfig();
    cartConfig.value = res.data || { max_items: 20, max_per_item: 20 };
  } catch { /* 默认值 */ }
  cartConfigVisible.value = true;
};

const handleSaveCartConfig = async () => {
  cartConfigSaving.value = true;
  try {
    await api.setCartConfig(cartConfig.value);
    ElMessage.success('保存成功');
    cartConfigVisible.value = false;
  } catch { ElMessage.error('保存失败'); }
  finally { cartConfigSaving.value = false; }
};

const quickUpdate = (r, f) => { api.updateMallProduct(r.id, { [f]: r[f] }); };

const handleDelete = (r) => {
  ElMessageBox.confirm('确定删除？将同时删除该商品所有规格', '提示').then(async () => {
    // 删除该 SPU 下所有 SKU
    if (r.spu_id) {
      const all = (await api.getMallProducts()).data || [];
      const skus = all.filter(p => p.spu_id === r.spu_id);
      for (const sku of skus) {
        await api.deleteMallProduct(sku.id);
      }
    } else {
      await api.deleteMallProduct(r.id);
    }
    ElMessage.success('删除成功');
    await fetchData();
  }).catch(() => {});
};

onMounted(async () => { await fetchCats(); await fetchData(); });

</script>
<style scoped>
.header-actions { display: flex; gap: 12px; align-items: center; }
</style>
